//Get login User Details
export const FETCH_QUOTE_LISTING_SUCCESS = 'FETCH_QUOTE_LISTING_SUCCESS';
export const FETCH_QUOTE_LISTING_FAILURE = 'FETCH_QUOTE_LISTING_FAILURE';
export const SAVE_QUOTE_FORM_DETAILS = 'SAVE_QUOTE_FORM_DETAILS';
export const SAVE_QUOTE_ITEMS_DETAILS = 'SAVE_QUOTE_ITEMS_DETAILS';
export const SAVE_ITEMS_DETAILS_IN_FORM = 'SAVE_ITEMS_DETAILS_IN_FORM';
export const RESET_SAVE_QUOTE_DETAILS = 'RESET_SAVE_QUOTE_DETAILS';
export const RESET = 'RESET';
